import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PageHeader } from '@/components/PageHeader';
import { BatchProcessingManager } from '@/components/BatchProcessingManager';
import { MultiDocumentExtractionHub } from '@/components/MultiDocumentExtractionHub';
import { EnterpriseWorkflowEngine } from '@/components/EnterpriseWorkflowEngine';
import { AdvancedAnalyticsDashboard } from '@/components/AdvancedAnalyticsDashboard';

const Phase6Dashboard: React.FC = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Phase 6: Advanced Batch Processing & Automation"
        description="Enterprise-grade batch processing, multi-document extraction, workflow automation, and advanced analytics"
      />

      <Tabs defaultValue="batch-processing" className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="batch-processing">Batch Processing</TabsTrigger>
          <TabsTrigger value="multi-document">Multi-Document Hub</TabsTrigger>
          <TabsTrigger value="workflow-engine">Workflow Engine</TabsTrigger>
          <TabsTrigger value="analytics">Advanced Analytics</TabsTrigger>
        </TabsList>

        <TabsContent value="batch-processing" className="space-y-6">
          <BatchProcessingManager />
        </TabsContent>

        <TabsContent value="multi-document" className="space-y-6">
          <MultiDocumentExtractionHub />
        </TabsContent>

        <TabsContent value="workflow-engine" className="space-y-6">
          <EnterpriseWorkflowEngine />
        </TabsContent>

        <TabsContent value="analytics" className="space-y-6">
          <AdvancedAnalyticsDashboard />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Phase6Dashboard;